export default "skymp5-front/cb339e63ba0a96c297fad9db03e15565.svg";